import { Box, Card, Tag, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

interface Props {
  title: string
  description: string
  tag?: string
  disabled?: boolean
  disabledTooltip?: string
  onClick: () => void
}

const SendInBulkModeCard = ({
  title,
  description,
  tag,
  disabled = false,
  disabledTooltip,
  onClick,
}: Props) => {
  const [hover, onHover] = useToggle()

  const cardContent = (
    <>
      <Card.Title>{title}</Card.Title>
      <Card.Content>
        {description}
        {tag && (
          <Box gap="s32" paddingTop="s8">
            <Tag type={'champagne'} icon="crown" leftItem="icon">
              {tag}
            </Tag>
          </Box>
        )}
      </Card.Content>
    </>
  )

  if (disabled) {
    return (
      <Tooltip.Alt label={disabledTooltip} attachment="bottom center" open={hover} toggle={onHover}>
        <Box
          borderRadius={{ all: 'abs012' }}
          paddingX="s24"
          paddingY="s16"
          gap="s8"
          height="full"
          background="grey400"
          onMouseEnter={onHover(true)}
          onMouseLeave={onHover(false)}
        >
          {cardContent}
        </Box>
      </Tooltip.Alt>
    )
  }

  return <Card onClick={onClick}>{cardContent}</Card>
}

export default SendInBulkModeCard
